import { Outlet } from 'react-router-dom';
import { useMindbox, useRefreshPage } from 'common/hooks';

const MainLayout = () => {
  useRefreshPage();
  useMindbox();

  return (
    <>
      <Outlet />
    </>
  );
};

export default MainLayout;
